module.exports = __webpack_public_path__ + "img/avatar_default_5.4f4ede29.svg";